const user = localStorage.getItem(`UserData`);
const token = localStorage.getItem(`AuthToken`);
const showwizarState: string | null = localStorage.getItem("ShowWizard");

const userobj = JSON.parse(user ?? "{}");
const default_state = {
  SelectedOrg: {},
  selectedUser: {},
  selectedEmployee: {},
  selectedDept: {},
  breadcrumbsTitle: "Home",
  SidebarRenderView: <>Default view</>,
  showWizard: showwizarState ? JSON.parse(showwizarState) : true,
  Allmodules: [],
  config: {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  },
  authuser: userobj,
  isloading: false,
  modalOBJ: {},
  verifyemail: "",
  showmodal: false,
};

const reducer = (
  state: any = default_state,
  action: { type: string; payload?: any }
) => {
  switch (action.type) {
    case "set-config":
      return { ...state, config: action.payload };
    case "set-breadTitle":
      return { ...state, breadcrumbsTitle: action.payload };
    case "set-authuser":
      return { ...state, authuser: action.payload };
    case "set-selectedUser":
      return { ...state, selectedUser: action.payload };
    case "set-loading":
      return { ...state, isloading: action.payload };
    case "set-showWizard":
      return { ...state, showWizard: action.payload };

    case "set-verifyEmail":
      return { ...state, verifyemail: action.payload };
    case "set-selected-org":
      return { ...state, SelectedOrg: action.payload };

    case "set-modal":
      return { ...state, showmodal: action.payload };
    case "set-modalProps":
      return { ...state, modalOBJ: action.payload };

    case "set-modules":
      return { ...state, Allmodules: action.payload };

    case "set-selectedemployee":
      return { ...state, selectedEmployee: action.payload };

    case "set-sidebarrender":
      return { ...state, SidebarRenderView: action.payload };
    case "set-selectedDept":
      return { ...state, selectedDept: action.payload };

    default:
      return { ...state };
  }
};
export { reducer };
